import React, { useEffect } from "react";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import ManageOwners from "../../components/generic/ManageOwners";
import {fetchRestaurantById, manageRestaurantOwner} from "../../store/restaurant-slice";
import {fetchUserList} from "../../store/list-slice";

const RestaurantManageOwners = () => {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const list = useSelector(state => state.list);
    const {
        items,
        fetchByIdStatus,
        manageOwnerStatus,
    } = useSelector(state => state.restaurant);

    const restaurant = fetchByIdStatus === "success" && items.find(item => item.id === params.restaurantId);
    const existingOwners = restaurant?.owners?.map(owner => ({
        user: owner._id,
        percentage: owner.stakePercentage
    })) || [];

    useEffect(() => {
        dispatch(fetchUserList());
    }, [dispatch]);


    useEffect(() => {
        dispatch(fetchRestaurantById(params.restaurantId)); // Adjust based on your actual Redux action
    }, [dispatch, params.restaurantId]);

    useEffect(() => {
        if (manageOwnerStatus === "success") {
            navigate("../..");
        }
    }, [manageOwnerStatus, navigate]);

    const handleFormSubmit = (data) => {
        dispatch(manageRestaurantOwner({ id: params.restaurantId, owners: data }));
    }

    return (
        <>
            <SubHeader title="Manage restaurant owners">
                <Button to="../../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>

            <div className="container p-0 ms-0">
                <div className="row">
                    <ManageOwners onFromSubmit={handleFormSubmit} list={list} existingOwners={existingOwners}/>
                </div>
            </div>
        </>
    );
};

export default RestaurantManageOwners;
